import { Box, Stack, Typography } from "@mui/material";

interface QuotaTooltipContentProps {
  monthlyLimit: number | string;
  rollover: number;
  usage: number;
  isUnlimited: boolean;
}

export default function QuotaTooltipContent({
  monthlyLimit,
  rollover,
  usage,
  isUnlimited,
}: QuotaTooltipContentProps) {
  const formatNumber = (num: number) => num.toLocaleString();

  return (
    <Box sx={{ p: 0.5, minWidth: 180 }}>
      <Stack spacing={1.5}>
        <Box>
          <Typography
            variant="captionReg"
            component="div"
            sx={{ color: "rgba(255,255,255,0.7)", mb: 0.25 }}
          >
            Monthly Limit
          </Typography>
          <Typography
            variant="body2Semi"
            component="div"
            sx={{ color: "#fff" }}
          >
            {isUnlimited ? "Unlimited" : formatNumber(Number(monthlyLimit))}
          </Typography>
        </Box>

        {!isUnlimited && (
          <Box>
            <Typography
              variant="captionReg"
              component="div"
              sx={{ color: "rgba(255,255,255,0.7)", mb: 0.25 }}
            >
              Rollover
            </Typography>
            <Typography
              variant="body2Semi"
              component="div"
              sx={{ color: "#fff" }}
            >
              {rollover > 0 ? `+${formatNumber(rollover)}` : 0}
            </Typography>
          </Box>
        )}

        <Box>
          <Typography
            variant="captionReg"
            component="div"
            sx={{ color: "rgba(255,255,255,0.7)", mb: 0.25 }}
          >
            Current Usage
          </Typography>
          <Typography
            variant="body2Semi"
            component="div"
            sx={{ color: "#fff" }}
          >
            {formatNumber(usage)}
          </Typography>
        </Box>
      </Stack>
    </Box>
  );
}
